import type { ReactNode } from 'react';
import { Building2, Plus } from 'lucide-react';
import { Button } from '@/components/ui';

type EntityCardsContainerProps = {
	hasAnyEntities: boolean;
	hasVisibleEntities: boolean;
	emptyInitialTitle: string;
	emptyInitialDescription: string;
	emptySearchTitle?: string;
	emptySearchDescription?: string;
	emptyActionText: string;
	onEmptyActionClick: () => void;
	children: ReactNode;
};

export const EntityCardsContainer = ({
	hasAnyEntities,
	hasVisibleEntities,
	emptyInitialTitle,
	emptyInitialDescription,
	emptySearchTitle = 'Nenhum resultado encontrado',
	emptySearchDescription = 'Tente outro termo de busca.',
	emptyActionText,
	onEmptyActionClick,
	children,
}: EntityCardsContainerProps) => {
	if (!hasVisibleEntities) {
		return (
			<div className="flex flex-col items-center justify-center rounded-[2rem] border border-dashed border-stone-200 bg-stone-50/50 py-20 text-center">
				<div className="mb-4 rounded-full bg-white p-4 text-stone-300 shadow-sm">
					<Building2 size={32} />
				</div>
				<h3 className="text-base font-bold text-stone-900">
					{hasAnyEntities ? emptySearchTitle : emptyInitialTitle}
				</h3>
				<p className="mx-auto mt-1 max-w-sm text-sm leading-relaxed text-stone-500">
					{hasAnyEntities
						? emptySearchDescription
						: emptyInitialDescription}
				</p>
				{!hasAnyEntities && (
					<Button
						text={emptyActionText}
						variant="outline"
						className="mt-4 rounded-full border-stone-300 px-5 py-2 font-bold"
						startIcon={<Plus className="size-4 stroke-[3]" />}
						onClick={onEmptyActionClick}
					/>
				)}
			</div>
		);
	}

	return (
		<div className="grid grid-cols-1 items-stretch gap-4 md:grid-cols-2 xl:grid-cols-3">
			{children}
		</div>
	);
};
